import React from 'react';

function AdminField({ data, value, maxLength }) {
  const admin = data?.admin;

  if (!admin?._id) return <>-</>;

  const customerInfo = data?.customerInfo;
  const office = customerInfo?.office;

  if (office && office?._id) {
    const responsible = [value, office.businessName, office.office]
      .filter((part) => typeof part === 'string' && part.trim())
      .join(' - ');

    return <>{responsible}</>;
  }

  return <>{value}</>;
}

export default AdminField;
